import * as React from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

const mxn = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
  minimumFractionDigits: 2,
});

// Bloquea texto alfabético, formatea visualmente a moneda ($1,250.00) y
// devuelve SIEMPRE un número decimal limpio (float) o null al onChange.
export const CurrencyField = React.forwardRef(
  ({ value, onChange, className, allowNegative = false, ...props }, ref) => {
    const [focused, setFocused] = React.useState(false);
    const [raw, setRaw] = React.useState(
      value != null && value !== "" ? String(value) : ""
    );

    React.useEffect(() => {
      if (!focused) setRaw(value != null && value !== "" ? String(value) : "");
    }, [value, focused]);

    const handleChange = (e) => {
      const neg = allowNegative && /^\s*-/.test(e.target.value);
      let v = e.target.value.replace(/[^0-9.]/g, "");
      const parts = v.split(".");
      if (parts.length > 2) v = parts[0] + "." + parts.slice(1).join("");
      const dec = v.split(".");
      if (dec[1] !== undefined) v = dec[0] + "." + dec[1].slice(0, 2); // moneda: máx 2 decimales
      if (neg && v !== "") v = "-" + v;
      setRaw(v);
      onChange?.(v === "" || v === "." || v === "-" ? null : parseFloat(v));
    };

    const display = focused
      ? raw
      : value != null && value !== "" && !isNaN(Number(value))
      ? mxn.format(Number(value))
      : "";

    return (
      <Input
        ref={ref}
        inputMode="decimal"
        value={display}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={handleChange}
        className={cn("font-mono", className)}
        {...props}
      />
    );
  }
);
CurrencyField.displayName = "CurrencyField";
